import TransformComponent from '../Component/Transform';
import RelativePositionComponent from '../Component/Render/RelativePosition';
import Renderable from '../Component/Renderable';
import GameObject from '../GameObject/GameObject';
import Component from '../Component/Component';

export default class Container<
    T extends PIXI.Container = PIXI.Container
> extends GameObject<T> {
    public onCreate(params: any): void {
        this.name = params.name;
        this.addComponent<TransformComponent>(TransformComponent, params);

        if (params.relativePosition) {
            this.addComponent<RelativePositionComponent>(
                RelativePositionComponent,
                params
            );
        }

        this.addComponent<Renderable>(Renderable, params);
    }
}
